export type ClubRecommendation = {
  distance: number;
  club: string;
};

const clubRecommendations: ClubRecommendation[] = [
  { distance: 190, club: '1W' },
  { distance: 179, club: '3W' },
  { distance: 170, club: '3I' },
  { distance: 165, club: '5W' },
  { distance: 160, club: '4I' },
  { distance: 150, club: '5I' },
  { distance: 140, club: '6I' },
  { distance: 120, club: '7I' },
  { distance: 110, club: '8I' },
  { distance: 100, club: '9I' },
  { distance: 85, club: 'PW' },
  { distance: 70, club: 'SW' },
  { distance: 55, club: 'LW' },
].sort((a, b) => b.distance - a.distance);

/**
 * Get the recommended club based on the distance.
 * @param distance - The distance to the target.
 * @returns The recommended club for the given distance.
 */
export const getClubRecommendation = (distance: number): ClubRecommendation => {
  for (let i = 0; i < clubRecommendations.length; i++) {
    if (distance >= clubRecommendations[i].distance) {
      return clubRecommendations[i];
    }
  }
  return clubRecommendations[clubRecommendations.length - 1];
};
